import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators/map';
import uuid from 'uuid/v4';
import { authToOwner } from '@atlaskit/media-core';
import { downloadUrl } from '@atlaskit/media-common/downloadUrl';
import { MediaStore as MediaApi } from '../media-store';
import { isErrorFileState, isFinalFileState, isProcessingFileState, mapMediaFileToFileState, mapMediaItemToFileState } from '../../models/file-state';
import { FileFetcherError } from './error';
import { uploadFile } from '../../uploader';
import { getFileStreamsCache } from '../../file-streams-cache';
import { globalMediaEventEmitter } from '../../globalMediaEventEmitter';
import { RECENTS_COLLECTION } from '../../constants';
import isValidId from 'uuid-validate';
import { createFileDataloader } from '../../utils/createFileDataLoader';
import { getMediaTypeFromUploadableFile } from '../../utils/getMediaTypeFromUploadableFile';
import { overrideMediaTypeIfUnknown } from '../../utils/overrideMediaTypeIfUnknown';
import { convertBase64ToBlob } from '../../utils/convertBase64ToBlob';
import { toPromise, fromObservable } from '../../utils/mediaSubscribable';
import { getDimensionsFromBlob } from '../../utils/getDimensionsFromBlob';
import { createMediaSubject } from '../../utils/createMediaSubject';
import { isMimeTypeSupportedByBrowser, getMediaTypeFromMimeType } from '@atlaskit/media-common/mediaTypeUtils';
import { shouldFetchRemoteFileStates } from '../../utils/shouldFetchRemoteFileStates';
import { PollingFunction } from '../../utils/polling';
import { isEmptyFile } from '../../utils/detectEmptyFile';
import { mediaStore } from '@atlaskit/media-state';
import { fg } from '@atlaskit/platform-feature-flags';
export { isFileFetcherError, FileFetcherError } from './error';
export var FileFetcherImpl = /*#__PURE__*/function () {
  function FileFetcherImpl(mediaApi) {
    var _this = this;
    var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mediaStore;
    _classCallCheck(this, FileFetcherImpl);
    _defineProperty(this, "getErrorFileState", function (error, id, occurrenceKey) {
      return typeof error === 'string' ? {
        status: 'error',
        id: id,
        reason: error,
        occurrenceKey: occurrenceKey,
        message: error
      } : {
        status: 'error',
        id: id,
        reason: error === null || error === void 0 ? void 0 : error.reason,
        details: error === null || error === void 0 ? void 0 : error.attributes,
        occurrenceKey: occurrenceKey,
        message: error === null || error === void 0 ? void 0 : error.message
      };
    });
    _defineProperty(this, "setFileState", function (id, fileState) {
      _this.store.setState(function (state) {
        state.files[id] = fileState;
      });
    });
    // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
    _defineProperty(this, "createDownloadFileStream", function (id, collectionName, occurrenceKey) {
      var subject = createMediaSubject();
      var poll = new PollingFunction();

      // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
      poll.onError = function (error) {
        return subject.error(error);
      };
      poll.execute( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, fileState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.dataloader.load({
                id: id,
                collectionName: collectionName
              });
            case 2:
              response = _context.sent;
              if (response) {
                _context.next = 5;
                break;
              }
              throw new FileFetcherError('emptyItems', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
              });
            case 5:
              if (!isEmptyFile(response)) {
                _context.next = 7;
                break;
              }
              throw new FileFetcherError('zeroVersionFile', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
              });
            case 7:
              fileState = mapMediaItemToFileState(id, response);
              subject.next(fileState);
              _context.t0 = fileState.status;
              _context.next = _context.t0 === 'processing' ? 12 : _context.t0 === 'processed' ? 14 : 16;
              break;
            case 12:
              // the only case for continuing polling, otherwise this function is run once only
              poll.next();
              return _context.abrupt("break", 16);
            case 14:
              subject.complete();
              return _context.abrupt("break", 16);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      return subject;
    });
    _defineProperty(this, "getUploadingFileStateBase", function (file, upfrontId) {
      // TODO: DO not modify the input parameter 'content' attribute
      if (typeof file.content === 'string') {
        file.content = convertBase64ToBlob(file.content);
      }
      var content = file.content,
        _file$name = file.name,
        name = _file$name === void 0 ? '' : _file$name;
      var id = upfrontId.id,
        occurrenceKey = upfrontId.occurrenceKey;
      var preview;
      // TODO [MSW-796]: get file size for base64
      var size = 0;
      var mimeType = '';
      if (content instanceof Blob) {
        size = content.size;
        mimeType = content.type;
        if (isMimeTypeSupportedByBrowser(content.type) || fg('platform.media-svg-rendering')) {
          preview = {
            value: content,
            origin: 'local'
          };
        }
      }
      var mediaType = getMediaTypeFromUploadableFile(file);
      return {
        id: id,
        occurrenceKey: occurrenceKey,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        preview: preview
      };
    });
    this.mediaApi = mediaApi;
    this.store = store;
    this.dataloader = createFileDataloader(mediaApi);
  }
  _createClass(FileFetcherImpl, [{
    key: "getFileState",
    value: function getFileState(id) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var collectionName = options.collectionName,
        occurrenceKey = options.occurrenceKey;
      if (!isValidId(id)) {
        var subject = createMediaSubject();
        var err = new FileFetcherError('invalidFileId', id, {
          collectionName: collectionName,
          occurrenceKey: occurrenceKey
        });
        var errorFileState = {
          status: 'error',
          id: id,
          reason: err === null || err === void 0 ? void 0 : err.reason,
          message: err === null || err === void 0 ? void 0 : err.message,
          occurrenceKey: occurrenceKey,
          details: err === null || err === void 0 ? void 0 : err.attributes
        };
        subject.error(err);
        this.setFileState(id, errorFileState);
        return fromObservable(subject);
      }
      return fromObservable(getFileStreamsCache().getOrInsert(id, function () {
        var subject = _this2.createDownloadFileStream(id, collectionName);
        subject.subscribe({
          next: function next(fileState) {
            _this2.setFileState(id, fileState);
          },
          error: function error(err) {
            var errorFileState = _this2.getErrorFileState(err, id, occurrenceKey);
            _this2.setFileState(id, errorFileState);
          }
        });
        return subject;
      }));
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState(id, options) {
      return toPromise(this.getFileState(id, options));
    }
  }, {
    key: "getArtifactURL",
    value: function getArtifactURL(artifacts, artifactName, collectionName) {
      return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
  }, {
    key: "getFileBinaryURL",
    value: function getFileBinaryURL(id, collectionName, maxAge) {
      return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
  }, {
    key: "touchFiles",
    value: function touchFiles(descriptors, collection, traceContext) {
      return this.mediaApi.touchFiles({
        descriptors: descriptors
      }, {
        collection: collection
      }, traceContext).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      });
    }
  }, {
    key: "generateUploadableFileUpfrontIds",
    value: function generateUploadableFileUpfrontIds(collection, traceContext) {
      var id = uuid();
      var occurrenceKey = uuid();
      var touchFileDescriptor = {
        fileId: id,
        occurrenceKey: occurrenceKey,
        collection: collection
      };
      var deferredUploadId = this.touchFiles([touchFileDescriptor], collection, traceContext).then(function (touchedFiles) {
        return touchedFiles.created[0].uploadId;
      });
      return {
        id: id,
        occurrenceKey: occurrenceKey,
        deferredUploadId: deferredUploadId
      };
    }
  }, {
    key: "uploadExternal",
    value: function () {
      var _uploadExternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, collection, traceContext) {
        var _this3 = this;
        var uploadableFileUpfrontIds, id, occurrenceKey, subject, deferredBlob, preview, name, fileState;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
              id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
              subject = createMediaSubject();
              deferredBlob = fetch(url).then(function (response) {
                return response.blob();
              }).catch(function () {
                return undefined;
              });
              preview = new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
                  var blob;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return deferredBlob;
                      case 2:
                        blob = _context2.sent;
                        if (!blob) {
                          reject('Could not fetch the blob');
                        }
                        resolve({
                          value: blob,
                          origin: 'remote'
                        });
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x4, _x5) {
                  return _ref3.apply(this, arguments);
                };
              }());
              name = url.split('/').pop() || ''; // we create a initial fileState with the minimum info that we have at this point
              fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
              };
              subject.next(fileState);
              // we save it into the cache as soon as possible, in case someone subscribes
              getFileStreamsCache().set(id, subject);
              this.setFileState(id, fileState);
              return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                  var blob, type, size, file, mediaType, dimensions;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return deferredBlob;
                      case 2:
                        blob = _context3.sent;
                        if (blob) {
                          _context3.next = 5;
                          break;
                        }
                        return _context3.abrupt("return", reject('Could not download remote file'));
                      case 5:
                        type = blob.type, size = blob.size;
                        file = {
                          content: blob,
                          mimeType: type,
                          collection: collection,
                          name: name,
                          size: size
                        };
                        mediaType = getMediaTypeFromMimeType(type); // we emit a richer state after the blob is fetched
                        subject.next({
                          status: 'processing',
                          name: name,
                          size: size,
                          mediaType: mediaType,
                          mimeType: type,
                          id: id,
                          occurrenceKey: occurrenceKey,
                          preview: preview
                        });
                        // we don't want to wait for the file to be upload
                        _this3.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                        _context3.prev = 10;
                        _context3.next = 13;
                        return getDimensionsFromBlob(mediaType, blob);
                      case 13:
                        dimensions = _context3.sent;
                        _context3.next = 20;
                        break;
                      case 16:
                        _context3.prev = 16;
                        _context3.t0 = _context3["catch"](10);
                        reject(_context3.t0);
                        return _context3.abrupt("return");
                      case 20:
                        resolve({
                          dimensions: dimensions,
                          mimeType: type,
                          uploadableFileUpfrontIds: uploadableFileUpfrontIds
                        });
                      case 21:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[10, 16]]);
                }));
                return function (_x6, _x7) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function uploadExternal(_x, _x2, _x3) {
        return _uploadExternal.apply(this, arguments);
      }
      return uploadExternal;
    }()
  }, {
    key: "upload",
    value: function upload(file, controller, uploadableFileUpfrontIds, traceContext) {
      var _this4 = this;
      var collection = file.collection;
      var upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
      var id = upfrontId.id,
        occurrenceKey = upfrontId.occurrenceKey;
      var stateBase = this.getUploadingFileStateBase(file, upfrontId);
      var subject = createMediaSubject();
      getFileStreamsCache().set(id, subject);
      var onProgress = function onProgress(progress) {
        var fileState = _objectSpread(_objectSpread({
          status: 'uploading'
        }, stateBase), {}, {
          progress: progress
        });
        subject.next(fileState);
        _this4.setFileState(id, fileState);
      };
      var processingSubscription = new Subscription();
      var onUploadFinish = function onUploadFinish(error) {
        if (error) {
          var errorFileState = _this4.getErrorFileState(error, id, occurrenceKey);
          _this4.setFileState(id, errorFileState);
          return subject.error(error);
        }
        processingSubscription = _this4.createDownloadFileStream(id, collection, occurrenceKey).pipe(map(function (remoteFileState) {
          return _objectSpread(_objectSpread(_objectSpread({}, stateBase), remoteFileState), overrideMediaTypeIfUnknown(remoteFileState, stateBase.mediaType));
        })).subscribe({
          next: function next(fileState) {
            subject.next(fileState);
            _this4.setFileState(id, fileState);
          },
          error: function error(err) {
            var errorFileState = _this4.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            _this4.setFileState(id, errorFileState);
          },
          complete: subject.complete
        });
      };
      var _uploadFile = uploadFile(file, this.mediaApi, upfrontId, {
          onUploadFinish: onUploadFinish,
          onProgress: onProgress
        }, traceContext),
        cancel = _uploadFile.cancel;
      controller === null || controller === void 0 || controller.setAbort(function () {
        cancel();
        // TODO: filestate should turn to "Aborted" or something.
        // Consider canceling an upload that is already finished
        processingSubscription.unsubscribe();
      });

      // We should report progress asynchronously, since this is what consumer expects
      // (otherwise in newUploadService file-converting event will be emitted before files-added)
      setTimeout(onProgress, 0, 0);
      return fromObservable(subject);
    }
  }, {
    key: "downloadBinary",
    value: function () {
      var _downloadBinary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var name,
          collectionName,
          url,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              name = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 'download';
              collectionName = _args5.length > 2 ? _args5[2] : undefined;
              _context5.next = 4;
              return this.mediaApi.getFileBinaryURL(id, collectionName);
            case 4:
              url = _context5.sent;
              downloadUrl(url, {
                name: name
              });
              globalMediaEventEmitter.emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === RECENTS_COLLECTION,
                viewingLevel: 'download'
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function downloadBinary(_x8) {
        return _downloadBinary.apply(this, arguments);
      }
      return downloadBinary;
    }()
  }, {
    key: "copyFile",
    value: function () {
      var _copyFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(source, destination) {
        var _this5 = this;
        var options,
          traceContext,
          authProvider,
          sourceCollection,
          id,
          destinationAuthProvider,
          destinationCollectionName,
          replaceFileId,
          occurrenceKey,
          preview,
          mimeType,
          mediaStore,
          owner,
          body,
          params,
          cache,
          processingSubscription,
          _yield$mediaStore$cop,
          copiedFile,
          copiedFileWithMimeType,
          copiedId,
          copiedMimeType,
          mediaType,
          copiedFileState,
          fileCache,
          subject,
          previewOverride,
          fileState,
          _fileState,
          _fileCache,
          replaceFileState,
          key,
          errorFileState,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              traceContext = _args6.length > 3 ? _args6[3] : undefined;
              authProvider = source.authProvider, sourceCollection = source.collection, id = source.id;
              destinationAuthProvider = destination.authProvider, destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
              preview = options.preview, mimeType = options.mimeType;
              mediaStore = destination.mediaStore || new MediaApi({
                authProvider: destinationAuthProvider
              });
              _context6.t0 = authToOwner;
              _context6.next = 9;
              return authProvider({
                collectionName: sourceCollection
              });
            case 9:
              _context6.t1 = _context6.sent;
              owner = (0, _context6.t0)(_context6.t1);
              body = {
                sourceFile: {
                  id: id,
                  collection: sourceCollection,
                  owner: owner
                }
              };
              params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
              };
              cache = getFileStreamsCache();
              _context6.prev = 14;
              _context6.next = 17;
              return mediaStore.copyFileWithToken(body, params, traceContext);
            case 17:
              _yield$mediaStore$cop = _context6.sent;
              copiedFile = _yield$mediaStore$cop.data;
              // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
              copiedFileWithMimeType = _objectSpread(_objectSpread({}, copiedFile), mimeType ? {
                mimeType: mimeType
              } : undefined);
              copiedId = copiedFileWithMimeType.id, copiedMimeType = copiedFileWithMimeType.mimeType; // backend may return an "unknown" mediaType just after the copy
              // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
              mediaType = copiedMimeType ? getMediaTypeFromMimeType(copiedMimeType) : 'unknown';
              copiedFileState = mapMediaFileToFileState({
                data: copiedFileWithMimeType
              });
              fileCache = cache.get(copiedId);
              subject = fileCache || createMediaSubject(); // if we were passed a "preview", we propagate it into the copiedFileState
              previewOverride = !isErrorFileState(copiedFileState) && !!preview ? {
                preview: preview
              } : {};
              _context6.t2 = !isFinalFileState(copiedFileState) &&
              // mimeType should always be returned by "copyFileWithToken"
              // but in case it's not, we don't want to penalize "copyFile"
              copiedMimeType;
              if (!_context6.t2) {
                _context6.next = 31;
                break;
              }
              _context6.next = 30;
              return shouldFetchRemoteFileStates(mediaType, copiedMimeType, preview);
            case 30:
              _context6.t2 = _context6.sent;
            case 31:
              if (!_context6.t2) {
                _context6.next = 38;
                break;
              }
              fileState = _objectSpread(_objectSpread(_objectSpread({}, copiedFileState), overrideMediaTypeIfUnknown(copiedFileState, mediaType)), previewOverride);
              subject.next(fileState);
              this.setFileState(copiedId, fileState);
              processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                next: function next(remoteFileState) {
                  var fileState = _objectSpread(_objectSpread(_objectSpread({}, remoteFileState), overrideMediaTypeIfUnknown(remoteFileState, mediaType)), !isErrorFileState(remoteFileState) && previewOverride);
                  _this5.setFileState(copiedId, fileState);
                  return subject.next(fileState);
                },
                error: function error(err) {
                  var errorFileState = _this5.getErrorFileState(err, id, occurrenceKey);
                  _this5.setFileState(copiedId, errorFileState);
                  return subject.error(err);
                },
                complete: function complete() {
                  return subject.complete();
                }
              });
              _context6.next = 39;
              break;
            case 38:
              if (!isProcessingFileState(copiedFileState)) {
                _fileState = _objectSpread(_objectSpread({}, copiedFileState), !isErrorFileState(copiedFileState) && previewOverride);
                subject.next(_fileState);
                this.setFileState(copiedId, _fileState);
              }
            case 39:
              if (!cache.has(copiedId)) {
                getFileStreamsCache().set(copiedId, subject);
              }
              return _context6.abrupt("return", copiedFile);
            case 43:
              _context6.prev = 43;
              _context6.t3 = _context6["catch"](14);
              if (processingSubscription) {
                processingSubscription.unsubscribe();
              }
              if (replaceFileId) {
                _fileCache = cache.get(replaceFileId);
                replaceFileState = this.store.getState().files[replaceFileId];
                if (_fileCache) {
                  _fileCache.error(_context6.t3);
                } else {
                  // Create a new subject with the error state for new subscriptions
                  cache.set(id, createMediaSubject(_context6.t3));
                }
                key = replaceFileState ? replaceFileId : id;
                errorFileState = this.getErrorFileState(_context6.t3, id, occurrenceKey);
                this.setFileState(key, errorFileState);
              }
              throw _context6.t3;
            case 48:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[14, 43]]);
      }));
      function copyFile(_x9, _x10) {
        return _copyFile.apply(this, arguments);
      }
      return copyFile;
    }()
  }]);
  return FileFetcherImpl;
}();